import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appAlphabeticalSort'
})
export class AlphabeticalSortPipe implements PipeTransform {
  transform(array: any[],property: string): any[] {
    if (!Array.isArray(array)) {
      return array;
    }
    return array.sort((a, b) => a[property].localeCompare(b[property]));
  }
}
